import React from 'react';

const PostPhotoGalleryMediaItem = ({
	mediaType,
	src,
	width,
	height,
	videoThumbnail,
	showOverlay,
	overlayText,
	onClick,
}: {
	mediaType: string;
	src: string;
	width: number;
	height: number;
	videoThumbnail?: string;
	showOverlay?: boolean;
	overlayText?: string;
	onClick: () => void;
}) => {
	if (mediaType === 'video') {
		return (
			<span
				className={showOverlay ? 'react-photo-gallery-video-icon' : 'single-video-icon'}
				role="button"
				tabIndex={0}
				aria-label={overlayText ? `${overlayText}` : 'Open video'}
				onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						onClick();
					}
				}}
			>
				<img
					onClick={onClick}
					src={videoThumbnail}
					width={width}
					height={height}
					alt={overlayText ? overlayText : 'Video thumbnail'}
					className="react-photo-gallery-video"
					loading="lazy"
				/>
				<i className="ri-play-large-fill"></i>
				{showOverlay && (
					<div
						className="img-overlay"
						onClick={onClick}
						style={{ minWidth: `${width}px`, minHeight: `${height}px` }}
						title={overlayText}
					>
						{overlayText}
					</div>
				)}
			</span>
		);
	}
	// image
	return (
		<span
			className="react-photo-gallery-img"
			role="button"
			tabIndex={0}
			aria-label={overlayText ? `${overlayText}` : 'Open image'}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					onClick();
				}
			}}
		>
			<img onClick={onClick} src={src} width={width} height={height} alt="" loading="lazy" />
			{showOverlay && (
				<div
					className="img-overlay"
					onClick={onClick}
					style={{ minWidth: `${width}px`, minHeight: `${height}px` }}
					title={overlayText}
				>
					{overlayText}
				</div>
			)}
		</span>
	);
};

export default PostPhotoGalleryMediaItem;
